import { generateBreadcrumbs } from '@bv/utils/route/breadcrumbs/generate-breadcrumbs';

export const accountDetailsBreadcrumbs = generateBreadcrumbs({
  label: 'GLOBAL.SUBSCRIPTION_DETAILS',
  route: { name: 'account-details' },
});

export const integrationsBreadcrumbs = generateBreadcrumbs({
  label: 'integrations.title_trans',
  route: { name: 'integrations' },
});

export const webhooksBreadcrumbs = generateBreadcrumbs(
  { label: 'integrations.title_trans', route: { name: 'integrations' } },
  { label: 'integrations.webhooks.title_trans', route: { name: 'int-webhooks' } },
);

export const sallaBreadcrumbs = generateBreadcrumbs(
  { label: 'integrations.title_trans', route: { name: 'integrations' } },
  { label: 'integrations.marketplace.title_trans', route: { name: 'int-marketplace' } },
  { label: 'integrations.salla.integration_title_trans', route: { name: 'int-salla-integration' } },
);

export const mcpBreadcrumbs = generateBreadcrumbs(
  { label: 'integrations.title_trans', route: { name: 'integrations' } },
  { label: 'integrations.mcp.title_trans', route: { name: 'int-mcp' } },
);
